'use strict';

+function ($) {
  $.fn.button.Constructor.DEFAULTS.loadingText = '<span class="fa fa-circle-o-notch fa-spin"></span><span>Loading...</span>';

  $.fn.loader = function (option) {
    var show = option === 'show';
    return this.each(function () {
      $(this).toggleClass('in', show).toggleClass('out', !show);
    });
  };

  // generate, return, and display a 'loader' modal
  basecoat.loaderModal = function (message) {
    message = message || 'Loading...';
    var html = ''
    + '<div class="modal-body">'
      + '<span class="loader-spinner fade in"></span>'
      + (message ? '<span class="modal-message">' + message + '</span>' : '')
    + '</div>';
    return basecoat.modal(html, 'loader', 'auto');
  };

  $(document)
  // 'show' and 'hide' events for spinner-loader
  .on('show.bc.loader', '.loader-spinner', function () {
    $(this).loader('show');
  })
  .on('hide.bc.loader', '.loader-spinner', function () {
    $(this).loader('hide');
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/loader.js
// module id = 7
// module chunks = 0